// extracted by mini-css-extract-plugin
export default {"failed-icon-style":"FailedIcon_failed-icon-style__ffHWm"};